import Splide from '@splidejs/splide';

((Drupal, once) => {
  Drupal.behaviors.splideImages = {
    attach: (context, settings) => {
      // Get DOM references
      const mainSplide = document.querySelector('#main-splide');
      const thumbSplide = document.querySelector('#thumb-splide');
      if(!mainSplide || !thumbSplide) {
        return;
      }
      const hasMultipleImages = mainSplide.querySelectorAll('li').length > 1;

      // Declare options for the slides
      if (mainSplide) {
        const mainOptions = {
          autoWidth: false,
          autoHeight: true,
          type: 'fade',
          rewind: true,
          pagination: true,
          arrows: hasMultipleImages,
        };

        const thumbOptions = {
          width: '7.625rem',
          heightRatio: 5.246, //Roughly the ratio of thumnails in the prototype
          direction: 'ttb',
          gap: 30,
          rewind: true,
          pagination: false,
          isNavigation: true,
          arrows: false,
          perPage: 3,
          breakpoints: {
            // 1200 and below
            1200: {
              width: '5rem',
              gap: 25,
            },
            // 768 px and below
            768: {
              destroy: true,
            },
          },
        };

        // Create an instant for the Splide
        const main = new Splide(mainSplide, mainOptions);
        const thumb = new Splide(thumbSplide, thumbOptions);

        // Grab the slide with class "is-active" and set the background image of that element
        // to be the same as current image.
        const getBackgroundUrl = () => {
          let activeSlide = document.querySelector('li.is-active');
          let imageSource = activeSlide.querySelector('img').src;
          activeSlide.style.backgroundImage = `url('${imageSource}')`;
          return;
        };

        main.on('active move', () => {
          getBackgroundUrl();
        });

        // sync the main splide and the thumb splide and mount them
        main.sync(thumb);
        main.mount();
        thumb.mount();
      }
    },
  };
})(Drupal, once);
